import React from 'react'

const ProvidedServicesM2 = ({ imageSrc, mobileimage, title, des, reverse, w, h }) => {
  return (
    <div className="pb-4">

    {/* for larger screen */}
    <div className={`hidden md:flex items-center relative h-[85vh] ${reverse ? "" : "flex-row-reverse" }`}>

      {

        reverse ? <div className="absolute top-[50%] left-[30%] rounded-[100px] rotate-1 blur-[90px] transform -translate-x-56 -translate-y-24 bg-gradient-to-r from from-[#00c3ffdb] to-[#FF29C3] h-[150px] w-[300px]"></div> 

        : <div className="absolute top-[50%] right-[10px] rounded-[100px] rotate-1 blur-[90px] transform -translate-x-56 -translate-y-24 bg-gradient-to-r from from-[#00c3ffdb] to-[#FF29C3] h-[150px] w-[300px]"></div>
      
      }

      <div className={`w-1/2 relative z-10 flex ${reverse ? "justify-center items-center" : "justify-center items-center"}`}>
        <img src={imageSrc} alt={title} style={{
          width : w,
          height : h,
        }} />
      </div>

      <div className="w-1/2 relative z-10 px-[80px] ml-12  text-white">
        <h2 className="text-[38px] font-poppins font-bold bg-gradient-to-r from-[#FF29C3] to-[#F5D3F4] text-transparent bg-clip-text">{title}</h2>
        <p className="text-[22px] font-poppins font-normal text-[#F2F2F285] mt-[30px]">{des}</p>
      </div>

     </div>


    <div className="flex md:hidden flex-col items-center">

      <div className={`w-full`}>
        <img src={mobileimage} alt={title} className="w-full h-[302px] object-contain" />
      </div>

      <div className="w-[90%] mt-4 text-white text-center">
        <h2 className="text-[22px] text-center font-poppins font-bold bg-gradient-to-r from-[#FF29C3] to-[#F5D3F4] text-transparent bg-clip-text">{title}</h2>
        <p className="text-[16px] font-poppins font-normal text-[#F2F2F285] mt-[16px] mb-[30px]">{des}</p>
      </div>

      </div>

    </div>
  )
}

export default ProvidedServicesM2